<template>
  <div>
    <!-- 谷歌地图 -->
    <explore-google-maps v-if="!isShowReport"></explore-google-maps>
    <explore-report :user-id="userId" :store-id="storeId" :store-address-non-store-id="storeAddress" :store-name-non-store-id="storeName"  v-else></explore-report>
  </div>
</template>

<script>

import exploreGoogleMaps from "./explore-google-maps";
import ExploreReport from "./explore-report";
export default {
  props:{
    isShowReport:{
      default: false,
      type: Boolean
    },
    userId:{
      default: '',
      type: String
    },
    storeId:{
      default: '',
      type: String
    },
    storeName:{
      default: '',
      type: String
    },
    storeAddress:{
      default: '',
      type: String
    },
  },
  components:{
    ExploreReport,
    exploreGoogleMaps
  },
  data() {
    return {

    }
  },
  created() {


  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {}
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/vilocal/explore.vue